export var DropdownReducerActionTypes;
(function (DropdownReducerActionTypes) {
    DropdownReducerActionTypes["Searching"] = "Searching";
    DropdownReducerActionTypes["SearchResolved"] = "SearchResolved";
    DropdownReducerActionTypes["CloseList"] = "CloseList";
    DropdownReducerActionTypes["SelectOption"] = "SelectOption";
    DropdownReducerActionTypes["ClearOption"] = "ClearOption";
    DropdownReducerActionTypes["NavigateList"] = "NavigateList";
    DropdownReducerActionTypes["SetHighlightedOptionIndex"] = "SetHighlightedOptionIndex";
})(DropdownReducerActionTypes || (DropdownReducerActionTypes = {}));
//# sourceMappingURL=DropdownReducerActionTypes.js.map